import Clipboard from "clipboard";
const globalFunctions = {
    install(Vue) {
        Vue.prototype.$pretty = ({ key = undefined, message = "" }) => {
            if (key === undefined) {
                var start_key = `%c|==${"-".repeat(30)}==[ START PRETTY ]==${"-".repeat(30)}==|`;
                var end_key = `%c|==${"-".repeat(30)}==[ END PRETTY ]==${"-".repeat(30)}==|`;
            } else {
                var start_key = `%c|==${"-".repeat(30)}==[ START ${key.toUpperCase()} ]==${"-".repeat(30)}==|`;
                var end_key = `%c|==${"-".repeat(30)}==[ END ${key.toUpperCase()} ]==${"-".repeat(30)}==|`;
            }

            console.log(start_key, "font-weight: bold;");
            if (typeof message !== "string") {
                console.log(`${JSON.stringify(message, null, 2)}`);
            } else {
                console.log(`${message}`);
            }
            console.log(end_key, "font-weight: bold;");
        };

        Vue.prototype.$calculateTotalTransactionPrice = (field = null, object) => {
            if (field != null) {
                if (object[field] === "" || isNaN(object[field])) {
                    object[field] = "0.000";
                }
            }

            let searchString = "_details";
            let object_details = object[getKeyByString(object, searchString)];

            let subtotal = 0.0;

            if (object_details != undefined || object_details != null) {
                for (let i = 0; i < object_details.length; i++) {
                    const item = object_details[i];
                    const quantity = item.quantity;
                    const price = item.unit_price;

                    // Calculate item total before discount
                    let itemTotal = quantity * price;

                    // Apply discount
                    if (item.line_discount_type == "A") {
                        // Dollar amount discount
                        const discountAmount = parseFloat(item.line_discount_amount);
                        itemTotal -= discountAmount;
                    } else if (item.line_discount_type == "P") {
                        // Percentage discount
                        const discountPercentage = parseFloat(item.line_discount_percentage);
                        const discountAmount = (itemTotal * discountPercentage) / 100;
                        itemTotal -= discountAmount;
                    }

                    item.line_total = itemTotal.toFixed(3);
                    // Add item total to the subtotal
                    subtotal += itemTotal;
                }
            }

            object.subtotal = subtotal.toFixed(3);

            let total = object.subtotal;
            // Apply overall discount
            if (object.discount_type == "A" || object.discount_type == "$") {
                // Dollar amount discount
                const overallDiscountAmount = parseFloat(object.discount);
                total -= overallDiscountAmount;
            } else if (object.discount_type == "P" || object.discount_type == "%") {
                // Percentage discount
                const overallDiscountPercentage = parseFloat(object.discount);
                const overallDiscountAmount = (total * overallDiscountPercentage) / 100;
                total -= overallDiscountAmount;
            }

            // Calculate total including freight, customs, expedite fee, and handling charge
            let overalltotal =
                total + parseFloat(object.freight) + parseFloat(object.customs) + parseFloat(object.expedite_fee) + parseFloat(object.handling_charge);

            if (overalltotal < 0) {
                $calculateTotalTransactionPrice(object);
            }
            object.total_amount = Number(overalltotal).toFixed(3);
        };

        Vue.prototype.$formatMoney = (number, decPlaces, decSep, thouSep) => {
            (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces), (decSep = typeof decSep === "undefined" ? "." : decSep);
            thouSep = typeof thouSep === "undefined" ? "," : thouSep;
            var sign = number < 0 ? "-" : "";
            var i = String(parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces))));
            var j = (j = i.length) > 3 ? j % 3 : 0;

            return (
                sign +
                (j ? i.substr(0, j) + thouSep : "") +
                i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
                (decPlaces
                    ? decSep +
                      Math.abs(number - i)
                          .toFixed(decPlaces)
                          .slice(2)
                    : "")
            );
        };

        Vue.prototype.$copyToClipboard = (text) => {
            const clipboard = new Clipboard(document.body, {
                text: () => text,
            });

            // Trigger the copy action
            clipboard.on("success", (e) => {
                e.clearSelection();
                clipboard.destroy();
                // You can add success logic here
                Vue.notify({
                    group: "loggedIn",
                    type: "success",
                    text: "Copied to Clipboard.",
                });
            });

            clipboard.on("error", (e) => {
                clipboard.destroy();
                // Handle errors here
                Vue.notify({
                    group: "loggedIn",
                    type: "error",
                    text: "Error copying text.",
                });
            });

            document.body.click(); // Trigger a click event to copy the text

            return clipboard;
        };

        Vue.prototype.$textTruncate = (str, length, ending) => {
            if (length == null) {
                length = 100;
            }
            if (ending == null) {
                ending = "...";
            }
            if (str.length > length) {
                return str.substring(0, length - ending.length) + ending;
            } else {
                return str;
            }
        };

        Vue.prototype.$isSet = (value) => {
            if (value === undefined || value === null || value === "") {
                return false;
            } else {
                return true;
            }
        };
        Vue.prototype.$isObjectSet = (object) => {
            if (object === undefined || object === null || Object.keys(object).length === 0) {
                return false;
            } else {
                return true;
            }
        };
        Vue.prototype.$isArraySet = (array) => {
            if (array === undefined || array === null || array.length === 0) {
                return false;
            } else {
                return true;
            }
        };
    },
};

function getKeyByString(object, searchString) {
    for (const key in object) {
        if (object.hasOwnProperty(key) && key.endsWith(searchString)) {
            return key;
        }
    }
    return null;
}

export default globalFunctions;
